import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintBASTRunahUmumTapak = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocBASTRunahUmumTapak = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          BERITA ACARA SERAH TERIMA
          <br /> RUMAH UMUM TAPAK
        </div>

        <div style={{ padding: "10px" }}>
          <p>Berdasarkan PPJB/AJB*) No. ........... Tanggal : ............................ 20...................... telah dilakukan serah terima pada tanggal ............................ 20...................... dari Pengembang ...................... (diisi nama Pengembang) , selanjutnya disebut “Pihak Pertama”;</p>
          <div style={{ marginTop: "10px" }}>Kepada pembeli:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "10px" }}>{"1."}</td>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"2."}</td>
                <td>NIK</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"3."}</td>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"4."}</td>
                <td>Nomor Telp./HP</td>
                <td>:</td>
                <td>{item.sls_appl?.phone ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginBottom: "20px" }}>
            selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Pihak Kedua”</span>
          </div>

          <div style={{ marginTop: "10px" }}>Atas 1 (Satu) unit Rumah Umum Tapak pada lokasi sebagai berikut:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "10px" }}>{"1."}</td>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Perumahan</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{""}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"2."}</td>
                <td>No. Rumah</td>
                <td>:</td>
                <td>{""}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"3."}</td>
                <td>Luas Tanah dan Lantai Rumah</td>
                <td>:</td>
                <td>{""}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"4."}</td>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{""}</td>
              </tr>
              <tr>
                <td style={{ width: "10px" }}>{"5."}</td>
                <td>Kota/Kabupaten/Provinsi</td>
                <td>:</td>
                <td>{""}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginBottom: "20px" }}>
            Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Obyek Serah Terima”</span>
          </div>

          <div style={{ marginTop: "20px" }}>Obyek Serah Terima dengan kondisi laik fungsi dan dilengkapi dengan:</div>
          <ol style={{ paddingLeft: "15px" }}>
            <li>Jaringan air bersih sudah berfungsi;</li>
            <li>Jaringan listrik sudah berfungsi;</li>
            <li>Jalan lingkungan sudah selesai dan berfungsi;</li>
            <li>Saluran/drainase lingkungan sudah selesai dan berfungsi;</li>
            <li>Saluran air limbah/air kotor rumah tangga sudah selesai dan berfungsi; dan</li>
            <li>Sarana pewadahan sampah individual dan tempat pembuangan sampah sementara.</li>
          </ol>
          <p>Demikian berita acara serah terima ini ditandatangani oleh kedua belah pihak dan dapat dipertanggungjawabkan.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "70%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  Pihak Pertama/Kuasa*,
                  <br />
                  <span style={{ fontWeight: "bold" }}>ANGGA BUDI KUSUMA</span>
                  <br />
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  Pihak Kedua
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  Nama Lengkap, Jabatan dan Stempel
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  {item.sls_appl?.address ?? "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>*) coret salah yang tidak perlu</p>
      </div>
    </div>
  );
};
